import styled from 'styled-components';

const HeroHomeStyle = styled.section`
	--sizeImage: 50%;

	--h1L: calc(var(--h1) * 2);

	margin-bottom: var(--sectionDistance);

	.hero-container {
		position: relative;
	}

	.logo-text-animation {
		opacity: 0;
		transition: var(--trTime) ease-in calc(var(--trTime) * 5);
	}

	.all-text-hero {
		opacity: 0;
		transition: var(--trTime) ease-in calc(var(--trTime) * 2);
	}

	.image-block {
		.image-cont {
			--proportion: 0;

			transform: scale(0);
			transition: calc(var(--trTime) * 2) ease-in-out;

			img {
				position: relative !important;
				height: calc(100dvh - var(--headerHeight)) !important;
			}

			/* &:before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				opacity: 0.3;
				background-color: var(--black);
				z-index: 1;
			} */
		}
	}

	.info-block {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;

		.container {
			height: 100%;
		}
	}

	.info-inner-block {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.h1-block {
		display: flex;
		flex-direction: column;
	}

	.hero-titleL {
		font-size: var(--h1L);
	}

	.align-end {
		text-align: end;
	}

	.shadow {
		text-shadow: var(--white) 1px 0 12px;
	}

	&.active {
		.image-block {
			.image-cont {
				transform: scale(1);
			}
		}

		.all-text-hero,
		.logo-text-animation {
			opacity: 1;
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		.image-block {
			.image-cont {
				--proportion: var(--sizeImage);

				img {
					position: absolute !important;
					height: 100% !important;
				}
			}
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--sizeImage: 60%;
		--h1L: calc(var(--h1) * 1.5);

		.hero-title {
			font-size: calc(var(--h1) / 2);
		}
	}
`;

export default HeroHomeStyle;
